<template>
    <b-modal v-model="internalShow" @hide="$emit('update:show', false)" :title="$t('auth.session.title')" static hide-header-close no-close-on-esc no-close-on-backdrop>
        {{ $t('auth.session.description') }} <countdown :end="end" @time-up="logout"></countdown>
        <countdown :end="modalShowTime" @time-up="internalShow = true" class="d-none"></countdown>
        <template v-slot:modal-footer>
            <button class="btn btn-outline-secondary" @click="logout">{{ $t('core.logout') }}</button>
            <button class="btn btn-primary" @click="extend">{{ $t('auth.session.action') }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import Countdown from '@/Components/Countdown'

export default {
    name: 'SessionLifetimeWarningModal',
    components: { BModal, Countdown },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            internalShow: false,
            end: 0,
            modalShowTime: 0,
        }
    },
    methods: {
        extend () {
            axios.post('/session/extend').then(response => {
                this.setTime()
                this.internalShow = false
            })
        },
        setTime () {
            var endTime = new Date()
            endTime.setMinutes(endTime.getMinutes() + Number.parseInt(lgt.sessionLifetime-5))
            this.end = endTime.getTime()

            var showTime = new Date()
            showTime.setMinutes(showTime.getMinutes() + Number.parseInt(lgt.sessionLifetime) - 10)
            this.modalShowTime = showTime.getTime()
        },
        logout () {
            axios.post('/logout').then(response => {
                window.location.href = '/login'
            })
        },
    },
    created () {
        this.setTime()
    },
}
</script>
